import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ScrollspyNavItem } from '~/components/ScrollspyNav';
import { ScrollspyNav } from '~/components/ScrollspyNav';
import styles from './OverviewTabNav.module.css';
const EMPTY_ITEMS: readonly ScrollspyNavItem[] = [];
export type OverviewTabNavProps = {
  items?: readonly ScrollspyNavItem[];
  offsetPx?: number;
};
export function OverviewTabNav(t0) {
  const $ = _c(6);
  const {
    items,
    offsetPx
  } = t0;
  const t = useTranslations("journey");
  const t1 = items ?? EMPTY_ITEMS;
  let t2;
  if ($[0] !== t) {
    t2 = t("overview_sections_aria_label");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== offsetPx || $[3] !== t1 || $[4] !== t2) {
    t3 = <ScrollspyNav items={t1} ariaLabel={t2} className={styles.fullBleed} offsetPx={offsetPx} />;
    $[2] = offsetPx;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}